import { FaDiscord, FaTwitter, FaInstagram, FaCopy } from 'react-icons/fa';

export const Contact = (props) => {
  const handleClick = (url) => {
    window.open(url);
  };
  const copyPolicy = () => {
    navigator.clipboard.writeText('d7eefa7b3becf54624a23095457a6cd023ceff3e0a9c988bab721d71')
  }
  return (
    <div>
      <div id="contact">
        <div className='social'>
          <ul>
            <li>
              <button onClick={() => handleClick(props.data ? props.data.instagram : '/')}>
                <h3><FaInstagram size={50} /></h3>
              </button>
            </li>
            {" "}
            <li>
            <button onClick={() => handleClick(props.data ? props.data.twitter : '/')}>
                <h3><FaTwitter size={50} /></h3>
              </button>
            </li>
            {" "}
            <li onClick={() => handleClick(props.data ? props.data.discord : '/')}>
              <button>
                <h3><FaDiscord size={50} /></h3>
              </button>
            </li>
          </ul>
          <div className='text-center'>
            <p style={{ wordBreak: 'break-all', marginBottom: 15, paddingRight: 10 }} >Policy Id: d7eefa7b3becf54624a23095457a6cd023ceff3e0a9c988bab721d71</p>
            <FaCopy style={{ cursor: 'pointer' }} onClick={copyPolicy} />
          </div>
          <div>
            <p style={{paddingBottom: 25}}>
            © 2022 The Greyhound Society. All rights reserved
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
